import { api } from '@/lib/api'

/**
 * @param {{ period?: string, from?: string, to?: string }} [options]
 */
export async function fetchHqDashboard(options = {}) {
  const params = {}
  if (options.period) params.period = options.period
  if (options.from) params.from = options.from
  if (options.to) params.to = options.to
  const { data } = await api.get('/hq/dashboard', { params })
  return data.data
}

/**
 * @param {string} phone
 * @param {number} [limit]
 */
export async function lookupHqCustomerByPhone(phone, limit = 25) {
  const { data } = await api.get('/hq/customers/lookup', {
    params: { phone, limit },
  })
  return data.data
}

/**
 * @param {{ service_id: number, branch_ids: number[], price_ladies?: number, price_gents?: number }} payload
 */
export async function pushHqServicePrices(payload) {
  const { data } = await api.post('/hq/service-price-push', payload)
  return data.data
}

/**
 * @param {{ package_id: number, branch_ids: number[], sale_price?: number, validity_days?: number }} payload
 */
export async function pushHqPackagePrices(payload) {
  const { data } = await api.post('/hq/package-push', payload)
  return data.data
}
